export const XHR_SENDER_TYPE = "rpldy-sender";